export default __webpack_public_path__ + "static/media/biker_in_route_active.ce1b295f.svg";